import React from "react";
import { getProductSlug } from "./HelperFunctions";

export const ProductList = ({ pagedItemGroups, isLoading }) => {
    const products = [];
    if (!isLoading) {
        for (var i = 0; i < pagedItemGroups.length; i++) {
            const item = pagedItemGroups[i];
            const productSlug = getProductSlug(item.Heading);
            products.push(
                <div
                    key={item.ItemGroupRecNo}
                    className="product d-flex flex-column tw-m-0 tw-flex-[0_0_48.75%] md:tw-flex-[0_0_32.45%] lg:tw-flex-[0_0_24.02%] tw-shadow-none hover:tw-shadow-none"
                    itemProp="itemListElement"
                    itemScope
                    itemType="http://schema.org/Product">
                    <meta content={item.ItemGroupRecNo} />
                    <meta itemProp="brand" content={item.VendName} />
                    <meta itemProp="category" content={model.SectionTitle} />
                    <meta itemProp="name" content={item.Heading} />

                    <PromoRibbon item={item} />
                    <ProductImage item={item} productSlug={productSlug} />
                    <ProductDetails item={item} productSlug={productSlug} />
                </div>
            );
        }
    }

    return (
        <>
            {products}
            <div key="sponsoredListing" id="sponsored-popover-content" style={{ display: "none" }}>
                <p className="small tk-trade-gothic-next">
                    Manufacturers use sponsored listings to help you discover and purchase their listing right where you'll be sure to see them.
                </p>
            </div>
        </>
    );
}

const PromoRibbon = ({ item }) => {
    if (item.RibbonText || item.OnSaleLabel) {
        if (item.OnSaleLabel) {
            const onSale = item.OnSaleLabel.toUpperCase().trim();
            if (onSale == "ON SALE" || onSale == "SALE") {
                item.OnSaleLabel = "SALE";
            }
        }
        var labelText = item.RibbonText ? item.RibbonText : item.OnSaleLabel;
        if (labelText.toLowerCase() == "new version!") labelText = "New Version";

        return (
            <div className={"ribbon-label tk-trade-gothic-next " + (item.IsNew ? 'ribbon-label-blue' : (labelText.toLowerCase() == 'new version' ? 'ribbon-label-grey' : 'ribbon-label-red'))} >
                <p><span className="tw-text-[12px]">{labelText}</span></p>
            </div>
        );
    }
}

const ProductImage = ({ item, productSlug }) => {
    if (item.ImageName == null || String(item.ImageName).trim() == '') {
        item.ImageName = "item-image-unavailable.jpg";
    }
    return (
        <div className="tw-cursor-pointer image-container tw-py-[50px] tw-mb-[4px] hover:tw-border-[#333333]" style={{ position: "relative", flexShrink: "0", border: "solid 1.5px #E0E0E0" }}
            onClick={() => window.location.href = "/products/details/" + item.ItemGroupRecNo + "/" + productSlug + "/"}>
            <SponsoredLabel item={item} />
            <img itemProp="image" src={"/Content/ProductImages/300x225/" + item.ImageName}
                style={{ aspectRatio: "1.333" }} className="tw-w-full"
                title={item.Heading} alt={item.ImageAltText} loading="lazy" />
        </div>
    );
}

const SponsoredLabel = ({ item }) => {
    if (item.SponsoredLabel == "Y") {
        return (
            <div className="sponsored-label tk-trade-gothic-next" style={{ position: "absolute", bottom: "-5px" }}>
                <p className="text-muted tw-gap-[2px] tw-flex" style={{ verticalAlign: "top", fontSize: "11px" }}>
                    <span>Sponsored</span>
                    <a data-placement="top">
                        <span className="fa-stack tw-h-[2.4em]" style={{ fontSize: "0.3rem" }}>
                            <i className="far fa-circle fa-stack-2x"></i>
                            <i className="fas fa-info fa-stack-1x"></i>
                        </span>
                    </a>
                </p>
            </div>
        );
    }
}

const ProductDetails = ({ item, productSlug }) => {
    var bestPrice = item.LowestPrice ? Number(item.LowestPrice).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "N/A";

    return (
        <div className="d-flex flex-column" itemProp="offers" itemScope itemType="http://schema.org/AggregateOffer">
            <meta itemProp="priceCurrency" content="USD" />
            <meta itemProp="price" content={bestPrice} />
            <meta itemProp="lowPrice" content={bestPrice} />
            {item.OnSaleUntilDate != null && (
                <meta itemprop="priceValidUntil" content={item.OnSaleUntilDate + "-08:00"} />
            )}

            <StockStatus item={item} productSlug={productSlug} />
            <div className="d-flex flex-column justify-content-between tk-trade-gothic-next">
                <a itemProp="url" href={"/products/details/" + item.ItemGroupRecNo + "/" + productSlug + "/"}>
                    <p
                        itemProp="name"
                        className="tw-text-left tw-p-0 tw-text-[14px] xl:tw-text-[17px] tw-font-bold tw-text-mine-shaft-1000 tw-leading-[19px] md:tw-leading-[21px] tw-mb-[6px]">
                        {item.Heading}
                    </p>
                </a>
            </div>
            {!!item.LowestPrice && (
                <div className="d-flex flex-row justify-content-between tk-trade-gothic-next tw-text-mine-shaft-1000 tw-text-[13px] xl:tw-text-[15px] tw-mt-[-2px]">
                    {(!item.IsSingleItem ? "from $" : "$") + bestPrice}
                </div>
            )}
        </div>
    );
}

const StockStatus = ({ item, productSlug }) => {
    if (item.Status == "IN STOCK") {
        return (
            <div className="tk-trade-gothic-next-condensed tw-text-[#999999] tw-text-left tw-text-[13px] xl:tw-text-[14px]">
                <link itemProp="availability" href="http://schema.org/InStock" />
                <span>{item.Status}</span>
            </div>
        );
    }
    else if (item.Status == "BACKORDER" || item.Status == "DIRECTSHIP") {
        return (
            <div className="tk-trade-gothic-next-condensed tw-text-[#999999] tw-text-left tw-text-[13px] xl:tw-text-[14px]">
                <link itemProp="availability" href="https://schema.org/LimitedAvailability" />
                <a href={"/products/details/" + item.ItemGroupRecNo + "/" + productSlug + "/"}>
                    <span className="tk-trade-gothic-next-condensed tw-text-[#999999] tw-text-left tw-text-[14px]">View Options</span>
                </a>
            </div>
        );
    }
}